
"use client";

import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../../../../components/navbar";
import Footer from "../../../../../components/footer";
import FilterSearch from "../../../../../components/FilterSearch(name)";
import Pagination from "../../../../../components/Pagination";
import styles from "../../css/Transactions/DebtorsTransactionsList.module.css";
import { LuFileText } from "react-icons/lu";
import { getDebtorsTransactions } from "../../../../../api/frontShop/DebtorsAPI.js";

function formatCurrency(amount) {
  const n = Number(amount || 0);
  return `R ${n.toLocaleString("en-ZA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export default function DebtorsTransactionList() {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 5;
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    async function load() {
      setLoading(true);
      setError("");
      try {
        const res = await getDebtorsTransactions({
          search: search || "",
          page: currentPage,
          pageSize,
        });
        const json = res?.data;
        if (cancelled) return;
        setRows(Array.isArray(json?.data) ? json.data : []);
        setTotal(Number(json?.total || 0));
      } catch (e) {
        if (!cancelled) setError(String(e?.message || e));
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, [search, currentPage]);

  const totalPages = Math.max(1, Math.ceil((total || 0) / pageSize));
  const pageRows = useMemo(() => rows, [rows]);

  return (
    <div className={styles.wrapper}>
      <Navbar backTo="/frontshop/debtors" />

      <div className={styles.container}>
        <div className={styles.toolbarRow}>
          <FilterSearch
            filterName="Filter"
            value={search}
            onChange={(v) => {
              setCurrentPage(1);
              setSearch(v);
            }}
            placeholder="Search"
            wrapperClassName={styles.filterSearch}
            labelClassName={styles.filterSearchLabel}
            searchContainerClassName={styles.filterSearchInputWrap}
            searchInputClassName={styles.filterSearchInput}
            iconColor="#A78BFA"
          />
        </div>

        <div className={styles.list}>
          {error ? <div className={styles.error}>{error}</div> : null}
          {loading ? <div className={styles.loading}>Loading...</div> : null}
          {pageRows.map((r) => (
            <button
              key={r.patientid ?? r.profilenumber}
              className={styles.row}
              onClick={() => {
                try {
                  sessionStorage.setItem("debtors_selected_transaction", JSON.stringify(r));
                } catch {}
                navigate("/frontshop/debtors/transactions/options", { state: { transaction: r } });
              }}
            >
              <div className={styles.left}>
                <div className={styles.iconWrap} aria-hidden="true">
                  <LuFileText />
                </div>
                <div className={styles.meta}>
                  <div className={styles.name}>{r.name}</div>
                </div>
              </div>
              <div className={styles.amount}>{formatCurrency(r.balance)}</div>
            </button>
          ))}
        </div>

        <div className={styles.paginationWrap}>
          <Pagination
            currentPage={Math.min(currentPage, totalPages)}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        </div>
      </div>

      <div className={styles.footerWrapper}>
        <Footer />
      </div>
    </div>
  );
}
